import { createFeatureSelector } from '@ngrx/store';

import { SidenavDataState } from './sidenav.reducer';

export const sidenavDataState = createFeatureSelector<SidenavDataState>('sidenav');
